import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { ncwSendAssetAtom, ncwTransferAmountAtom, ncwTransferRecipientAtom } from '../data-access';

export const useResetTransferState = () => {
	const setAmount = useSetAtom(ncwTransferAmountAtom);
	const setAsset = useSetAtom(ncwSendAssetAtom);
	const setRecipient = useSetAtom(ncwTransferRecipientAtom);

	useEffect(() => {
		setAmount(undefined);
		setAsset(undefined);
		setRecipient(undefined);
	}, []);
};
